import {
  ClearPendingReviewShiftsReducer,
  PendingReviewShiftsFavoriteBusiness,
  PendingReviewShiftsFetching,
  PendingReviewShiftsSetHasMore,
  PendingReviewShiftsUnfavoriteBusiness,
  GetPendingReviewShifts,
  GetPendingReviewShiftsErrors,
  GetPendingReviewShiftsWithoutConcat,
} from 'data/upshifter/PendingReviewShifts/actions'
import { IPendingReviewShiftsReducer } from 'models/Shift'
import { Action, isType } from 'ts-action'

const initialState: IPendingReviewShiftsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const PendingReviewShiftsReducer = (
  state = initialState,
  action: Action,
) => {
  if (isType(action, GetPendingReviewShifts)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: [...state.data, ...data],
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, GetPendingReviewShiftsWithoutConcat)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: data,
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, GetPendingReviewShiftsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: payload,
    }
  }
  if (isType(action, PendingReviewShiftsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, PendingReviewShiftsSetHasMore)) {
    const { payload } = action
    return {
      ...state,
      hasMore: payload,
    }
  }
  if (isType(action, ClearPendingReviewShiftsReducer)) {
    return initialState
  }

  if (isType(action, PendingReviewShiftsFavoriteBusiness)) {
    const { payload } = action
    const modifiedShifts = state.data.map(shift => {
      if (shift.business_id === payload.model_favored.id) {
        const modifiedShift = shift
        modifiedShift.favored = true
        modifiedShift.favorite_id = payload.id
        return modifiedShift
      }
      return shift
    })
    return {
      ...state,
      data: modifiedShifts,
    }
  }
  if (isType(action, PendingReviewShiftsUnfavoriteBusiness)) {
    const { payload } = action
    const unfavoritedShifts = state.data.map(shift => {
      if (shift.business_id === payload) {
        const unfavoritedShift = shift
        unfavoritedShift.favored = false
        unfavoritedShift.favorite_id = null
        return unfavoritedShift
      }
      return shift
    })
    return {
      ...state,
      data: unfavoritedShifts,
    }
  }
  return state
}
